import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { formatCurrency, formatAwsDateString } from "@covertree/utils";
import { Row } from "@covertree/ui/table/types";

import { useAccessPattern } from "@hooks/useAccessPattern";
import {
  GetQuoteFilterByStatus,
  SequoiaListItemFragment,
} from "@covertree/agent-portal-graphql";
import { SEQUOIA_CONTINUE_PATH } from "@routing/paths";

export const useMappedBookConversions = (
  bookConversionQuotes: SequoiaListItemFragment[] | undefined,
  statusFilter: GetQuoteFilterByStatus
) => {
  const navigate = useNavigate();
  const { canWriteBusiness: canContinueQuote } = useAccessPattern();

  return useMemo(() => {
    if (!bookConversionQuotes) return [];

    return bookConversionQuotes.map<Row>((quote) => ({
      id: quote.policyLocator,
      data: [
        quote.policyLocator,
        quote.selectedQuoteLocator,
        `${quote.policyholder.firstName} ${quote.policyholder.lastName}`,
        formatCurrency(quote.units[0].pricing.grossPremium),
        [
          quote.previousAddress.streetAddress,
          quote.previousAddress.city,
          quote.previousAddress.state,
          quote.previousAddress.zipCode,
        ].join(" "),
        formatAwsDateString(quote.startDate),
        quote.agencyInformation.agentName,
        quote.agencyInformation.agencyName,
        quote.bookConversion.source,
        quote.priorInsuranceDetails.priorCarrierName ?? "Not Listed",
        quote.bookConversion.previousPolicyId,
      ],
      ...(canContinueQuote && statusFilter === GetQuoteFilterByStatus.Valid
        ? {
            actionMenuItems: [
              {
                label: "Start book conversion",
                onClick: async () =>
                  navigate(`/${SEQUOIA_CONTINUE_PATH}/${quote.policyLocator}`, {
                    state: {
                      previousPath: location.pathname,
                    },
                  }),
              },
            ],
          }
        : {}),
    }));
  }, [bookConversionQuotes, statusFilter]);
};
